import { render } from "./CategoryListing.vue?vue&type=template&id=48363a29&scoped=true"
import script from "./CategoryListing.vue?vue&type=script&lang=js"
export * from "./CategoryListing.vue?vue&type=script&lang=js"

import "./CategoryListing.vue?vue&type=style&index=0&id=48363a29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48363a29"]])

export default __exports__